import http from '../utils/http'
import api from '.'

export function Login(data) {
    return http.post(api.Login.login, data)
}

